import React, { useState, useEffect } from "react";
import TauriCalendar from "./TauriCalendar/TauriCalendar";
import TauriImage from "../../TauriImage/TauriImage";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import "./PlanningView.css";
import { getAll } from "../../../localDB";
import { Button } from "react-bootstrap";
import SubmissionErrorModal from "../SubmissionErrorModal/SubmissionErrorModal";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import { planWorksheetStatusMapping } from "../../../visualizations/visualizations";
import RequestChangesModal from "../RequestChangesModal/RequestChangesModal";
import RejectPlanModal from "../RejectPlanModal/RejectPlanModal";

const PlanningView = (
  { selectedDate,
    setSelectedDate,
    worksheet,
    holidays,
    onSubmit,
    onApprove,
    isSubmitting,
    isApproving,
    policies,
    canApprove,
    canJoinCall,
    isManager,
    addActivityClick,
    addLeaveClick,
    addWorkWith,
    handleRemove }) => {
  const [details, setDetails] = useState([]);
  const [showRequestChangesModal, setShowRequestChangesModal] = useState(false);
  const [showRejectPlanModal, setShowRejectPlanModal] = useState(false);

  const handleAdd = (date) => {

  }
  
  const cycleStart = worksheet?.Cycle?.StartDate
    ? new Date(worksheet.Cycle.StartDate)
    : null;

  const cycleEnd = worksheet?.Cycle?.EndDate
    ? new Date(worksheet.Cycle.EndDate)
    : null;

  // Compare only year+month (so days don't matter)
  const currentMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const startMonth = cycleStart ? new Date(cycleStart.getFullYear(), cycleStart.getMonth(), 1) : null;
  const endMonth = cycleEnd ? new Date(cycleEnd.getFullYear(), cycleEnd.getMonth(), 1) : null;

  // Disable flags
  const disablePrev = startMonth && currentMonth <= startMonth;
  const disableNext = endMonth && currentMonth >= endMonth;

  const handlePrevMonth = () => {
    if (disablePrev) return; 
    setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    if (disableNext) return; 
    setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1));
  };

  return (
    <div className="opal-planning-view">
      <div className="date-section d-flex align-items-center justify-content-between">
        <TauriImage
          localImage={"/Images/arrow-left.svg"}
          className={`btn-arrowleft ${disablePrev ? "disabled-arrow" : ""}`}
          alt="btn"
          onClick={handlePrevMonth}
        />
        <div>
          <span className="me-2 cycle-code">{worksheet?.Cycle?.Code}</span>
          <span className="cycle-description">{worksheet?.Cycle?.Description}</span>
        </div>
        <TauriImage
          localImage={"/Images/arrow-right.svg"}
          className={`btn-arrowright ${disableNext ? "disabled-arrow" : ""}`}
          alt="btn"
          onClick={handleNextMonth}
        />
      </div>
      <TauriCalendar
        date={selectedDate}
        items={details}
        holidays={holidays}
        currentDate={selectedDate}
        handleAdd={handleAdd}
        handleRemove={handleRemove}
        handleClick={(date) => setSelectedDate(new Date(date))}
        worksheet={worksheet}
        policies={policies}
      />

      <div className="planning-view-footer">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex gap-2">
            {selectedDate &&
              <>
                <Button className="btn-applyLeave d-flex align-items-center p-0 m-0" onClick={addLeaveClick} disabled={isManager}>
                  <TauriImage localImage={"/Images/flat-color-icons--plus-primary.svg"} />
                  <span>Apply Leave</span>
                </Button>
                <Button className="btn-applyLeave d-flex align-items-center p-0 m-0" onClick={addActivityClick} disabled={isManager}>
                  <TauriImage localImage={"/Images/flat-color-icons--plus-primary.svg"} />
                  <span>Add Activity</span>
                </Button>
                {canJoinCall &&
                  <Button className="btn-applyLeave d-flex align-items-center p-0 m-0" onClick={addWorkWith} disabled={isManager}>
                    <TauriImage localImage={"/Images/flat-color-icons--plus-primary.svg"} />
                    <span>Work With</span>
                  </Button>
                }
              </>
            }
          </div>
          {/* {worksheet.Status === planWorksheetStatusMapping.AwaitingApproval &&
            <Button
              className="btn-reject d-flex align-items-center px-5"
              onClick={() => setShowRejectPlanModal(true)}>
              {isSubmitting && (
                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#000" />
              )}
              <span>Reject</span>
            </Button>
          }

        </div>
        <div className="d-flex">
          {worksheet.Status === planWorksheetStatusMapping.UpdateRequired &&
            <Button
              className="btn-requestChanges d-flex align-items-center px-3"
              onClick={() => setShowRequestChangesModal(true)}>
              {isSubmitting && (
                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#000" />
              )}
              <span className="text-nowrap">Request Changes</span>
            </Button>
          } */}

          {worksheet.Status === planWorksheetStatusMapping.ForSubmission &&
            <Button
              className="btn-submitPlan d-flex align-items-center px-3"
              onClick={onSubmit}
              disabled={isSubmitting || isManager || ![planWorksheetStatusMapping.ForSubmission, planWorksheetStatusMapping.UpdateRequired].includes(worksheet?.Status)}>
              {isSubmitting && (
                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
              )}
              <TauriImage localImage={"/Images/material-symbols--check-small.svg"} color={"#FFF"} />
              <span className="text-nowrap">Submit Plan</span>
            </Button>
          }

          {(worksheet.Status === planWorksheetStatusMapping.AwaitingApproval && canApprove) &&
            <Button
              className="btn-approvedPlan d-flex align-items-center px-3"
              onClick={onApprove}
              disabled={isApproving || ![planWorksheetStatusMapping.UpdateRequired, planWorksheetStatusMapping.AwaitingApproval].includes(worksheet?.Status)}>
              {isApproving && (
                <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
              )}
              <TauriImage localImage={"/Images/material-symbols--check-small.svg"} color={"#FFF"} />
              <span>Approve</span>
            </Button>
          }
        </div>
      </div>
      <RequestChangesModal show={showRequestChangesModal} onHide={() => setShowRequestChangesModal(false)} />
      <RejectPlanModal show={showRejectPlanModal} onHide={() => setShowRejectPlanModal(false)} />
    </div >
  );
};

export default PlanningView;
